import { Box, Container, Link, SimpleGrid, Text } from '@chakra-ui/react'
import FOOTER from '../constants/footer'
import ABOUT from '../constants/about'
import { ExternalLinkIcon } from '@chakra-ui/icons'

const Footer = () => {
  return (
    <Box>
      <Container maxW={'container.xl'}>
        <SimpleGrid
          columns={{
            base: 1,
            md: 4
          }}
          spacing={{
            base: 2
          }}
          spacingY={6}
          py={{
            base: 10,
            md: 14
          }}>
          <Box pb={4}>
            <Box display={'flex'} justifyContent={'start'}>
              <Text
                fontSize={{
                  base: '2.15rem',
                  lg: '2.15rem'
                }}
                fontWeight={700}
                bgColor={'green.200'}>
                Thank You
              </Text>
            </Box>
            <Text>For visiting</Text>
          </Box>
          <Box
            // bg='tomato'
            display={'flex'}
            flexDirection={'column'}
            alignItems={{
              // base: "center",
              md: 'start'
            }}
            gap={{
              base: 2,
              md: 3
            }}>
            <Text
              mb={1.5}
              fontSize={{
                base: '1.15rem',
                md: '1.35rem'
              }}
              fontWeight={700}>
              Profiles
            </Text>
            <Box>
              <Menu href={ABOUT.links.linkedin} text={'LinkedIn'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.gitlab} text={'Gitlab'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.github} text={'GitHub'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.shutterstock} text={'Shutterstock'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.behance} text={'Behance'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.adobe_stock} text={'Adobe Stock'} />
            </Box>
          </Box>

          <Box
            // bg='tomato'
            display={'flex'}
            flexDirection={'column'}
            alignItems={'start'}
            gap={{
              base: 2,
              md: 3
            }}>
            <Text
              mb={1.5}
              fontSize={{
                base: '1.15rem',
                md: '1.35rem'
              }}
              fontWeight={700}>
              Latest Projects
            </Text>

            {ABOUT.latest_projects.map((project, i) => {
              return (
                <Box key={i}>
                  <Menu href={project.link} text={project.title} />
                </Box>
              )
            })}
          </Box>

          <Box
            // bg='tomato'
            display={'flex'}
            flexDirection={'column'}
            alignItems={'start'}
            gap={{
              base: 2,
              md: 3
            }}>
            <Text
              mb={1.5}
              fontSize={{
                base: '1.15rem',
                md: '1.35rem'
              }}
              fontWeight={700}>
              Jobs
            </Text>

            <Box>
              <Menu href={ABOUT.links.upwork} text={'Upwork'} />
            </Box>
            <Box>
              <Menu href={ABOUT.links.projects_co_id} text={'Projects.co.id'} />
            </Box>
          </Box>
        </SimpleGrid>
      </Container>
      <hr />
      <Box
        py={4}
        px={{
          base: 4,
          md: 12,
          lg: 16
        }}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'flex-start'}>
        <Text
          fontSize={{
            base: '.7rem',
            sm: '.8rem',
            md: '.9rem'
          }}>
          {FOOTER.copyright}
        </Text>
        <Text
          fontSize={{
            base: '.7rem',
            sm: '.8rem',
            md: '.9rem'
          }}>
          {FOOTER.last_update}
        </Text>
      </Box>
    </Box>
  )
}

const Menu = ({ href, text }) => {
  return (
    <Link
      href={href}
      isExternal
      fontWeight={500}
      fontSize={{
        base: '1rem',
        md: '1rem'
      }}>
      {text} <ExternalLinkIcon mt={-1} color={'green.600'} />
    </Link>
  )
}

export default Footer
